import { Phone, Facebook, Mail } from "lucide-react";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="footer-section"
    className="flex min-h-[100svh] flex-col justify-center border-t border-black/10 text-royal-dark lg:min-h-screen"
  >
    <div className="mx-auto w-full max-w-3xl px-6 pt-24 pb-32 text-center lg:pt-32 lg:pb-40">
      <p
        data-testid="footer-thank-you"
        className="text-base font-medium leading-relaxed text-royal-dark md:text-lg"
      >
        Thank you for choosing Trumbull Paving Co. If you&rsquo;re satisfied
        with our work, please leave us a review on our Facebook page or Google
        profile. We appreciate your support!
      </p>
      <div className="mt-5 space-y-2">
        <p
          data-testid="footer-email"
          className="flex items-center justify-center gap-3 text-base font-semibold text-royal-dark md:text-lg"
        >
          <Mail className="h-5 w-5 shrink-0" />
          <a
            data-testid="footer-email-link"
            href="mailto:trumbullcont@aol.com"
            className="underline underline-offset-4 transition-colors duration-200 hover:text-royal-dark/60"
          >
            trumbullcont@aol.com
          </a>
        </p>
        <a
          data-testid="footer-call-link"
          href="tel:+13306372551"
          className="flex items-center justify-center gap-3 text-base font-semibold text-royal-dark transition-colors duration-200 hover:text-royal-dark/60 md:text-lg"
        >
          <Phone className="h-5 w-5 shrink-0" />
          330-637-2551
        </a>
      </div>
      <div className="mt-4 flex justify-center">
        <a
          data-testid="footer-facebook-link"
          href="https://www.facebook.com/share/19RzXrKSQL/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center transition-opacity duration-200 hover:opacity-70"
          aria-label="Facebook"
        >
          <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-[#1877F2]">
            <Facebook className="h-4 w-4 text-white" fill="currentColor" stroke="none" />
          </span>
        </a>
      </div>
      <div className="mt-2 flex justify-center">
        <a
          data-testid="footer-google-link"
          href="https://www.google.com/maps/place/Trumbull+Paving+Co.,+4474+Youngstown+Kingsville+Rd,+Cortland,+OH+44410/@41.3391119,-80.6562407,16z/data=!4m6!3m5!1s0x8833db1f97bf582f:0xf48575e7ca32c887!8m2!3d41.3391119!4d-80.6562407!16s%2Fg%2F1v3dssdp?authuser=1&hl=en&utm_campaign=as-npt-hbt&g_ep=Eg1tbF8yMDI2MDgyM18wIOC7DCoASAJQAg%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center transition-opacity duration-200 hover:opacity-70"
          aria-label="Google Business Profile"
        >
          <svg viewBox="0 0 48 48" className="h-6 w-6 shrink-0" aria-hidden="true">
            <circle cx="24" cy="24" r="22" fill="#4285F4" />
            <path
              d="M14 11h20l3 7c0 2.6-2.1 4.2-4.7 4.2S28 20.6 28 18c0 2.6-1.9 4.2-4 4.2s-4-1.6-4-4.2c0 2.6-2.1 4.2-4.7 4.2S11 20.6 11 18l3-7z"
              fill="#A8C7FA"
            />
            <text
              x="24"
              y="39"
              textAnchor="middle"
              fill="#FFFFFF"
              fontSize="17"
              fontWeight="bold"
              fontFamily="Arial, sans-serif"
            >
              G
            </text>
          </svg>
        </a>
      </div>
      <div className="mx-auto mt-5 w-64 overflow-hidden border border-royal-dark/25 bg-white">
        <iframe
          data-testid="google-map-embed"
          title="Trumbull Paving Co. — 4474 Youngstown Kingsville Rd, Cortland, OH 44410"
          src="https://www.google.com/maps?q=4474+Youngstown+Kingsville+Rd,+Cortland,+OH+44410&output=embed"
          className="h-32 w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
      <p
        data-testid="footer-address"
        className="mt-2 font-mono text-xs font-bold uppercase tracking-[0.2em] text-royal-dark/80"
      >
        4474 Youngstown Kingsville Rd, Cortland, OH 44410
      </p>
      <p className="mt-10 border-t border-royal-dark/15 pt-8 font-mono text-xs font-bold uppercase tracking-[0.2em] text-royal-dark">
        © 1984–2026 Trumbull Paving Co. — Trumbull County, Ohio
      </p>
      <p className="mt-3">
        <a
          href="/terms"
          data-testid="footer-terms-link"
          className="font-medium text-royal underline underline-offset-4 transition-colors duration-200 hover:text-royal-dark"
        >
          Terms of Service
        </a>
      </p>
      <p
        data-testid="footer-developer-credit"
        className="sr-only"
      >
        Website designed &amp; developed by Shaun Limbeck
      </p>
    </div>
  </footer>
);
